import React, { useEffect, useMemo } from 'react'
import { Global, css } from '@emotion/react'
import { useTbViewStore, useMatrix } from '@vt/hooks'
import { Table } from '@ow/ditto'
import OperateComponent from '../../widgets/operate'

const TableContainer = function ({
  beforeTransform,
  showTbDetail,
  onShowStatistics,
  sorts,
}) {
  const {
    fields,
    tbData,
    listConfig,
    selectedIds,
    destroyTbdata,
    recoverTbData,
    setSelectedIds,
    setSorts,
    loading,
    columnShowType,
    setColumnShowType,
    matrixTbData,
    matrixColumns,
    matrixCellInfo,
    matrixInited,
    matrixCustomFields,
    mergeStandardIds,
    matrixConfig,
    rowHeight,
  } = useTbViewStore([
    'fields',
    'tbData',
    'listConfig',
    'selectedIds',
    'destroyTbdata',
    'recoveryTbData',
    'setSelectedIds',
    'loading',
    'columnShowType',
    'setSorts',
    'setColumnShowType',
    'matrixTbData',
    'matrixColumns',
    'matrixCellInfo',
    'matrixCustomFields',
    'mergeStandardIds',
    'matrixInited',
    'matrixConfig',
    'rowHeight',
  ])

  const { fetchMatrixTbData, matrixMaterialData, filterStandards } = useMatrix()
  const { standardFieldsTitle, renderRowClass } = matrixConfig || {}

  useEffect(() => {
    // tbData变化后，处理大表数据
    const { areas = [], standards = [] } = matrixMaterialData || {}
    if (matrixInited && areas.length > 0 && standards.length > 0) {
      fetchMatrixTbData(
        tbData,
        fields,
        matrixCustomFields,
        standardFieldsTitle,
        areas,
        filterStandards,
        mergeStandardIds
      )
    }
  }, [
    tbData,
    matrixInited,
    matrixMaterialData,
    filterStandards,
    matrixCustomFields,
  ])

  const config = useMemo(() => {
    return {
      ...listConfig,
      fields: columnShowType,
    }
  }, [listConfig, columnShowType])

  const finalMatrixColumns = useMemo(() => {
    const arrMatrixColumns = matrixColumns || []
    // 原始 fields 用来帮助数据回显
    const arrFields = fields.map((v) => {
      return { ...v, hidden: true }
    })
    return [...arrMatrixColumns, ...arrFields]
  }, [matrixColumns, fields])

  if (
    (matrixColumns && matrixColumns.length === 0) ||
    (matrixTbData && matrixTbData.length === 0)
  ) {
    return <div className="w-full h-full relative" />
  }

  return (
    <>
      <Global
        styles={css`
          .matrix-table {
            .BaseTable__table-main .BaseTable__header-cell,
            .BaseTable__table-main .BaseTable__row-cell {
              border-right: 1px solid #dde1e3;
            }
          }
        `}
      />
      <div className="matrix-table w-full h-full relative">
        <Table
          fields={finalMatrixColumns}
          tbData={matrixTbData}
          loading={loading}
          isShowSelections={false}
          selectedIds={selectedIds}
          mergeCellInfo={matrixCellInfo}
          defaultSorts={sorts}
          beforeTransform={beforeTransform}
          onChangeSelected={setSelectedIds}
          onChangeSorts={setSorts}
          config={config}
          showTbDetail={showTbDetail}
          getSlug={(x) => x.slug}
          destroyTbData={destroyTbdata}
          recoverTbData={recoverTbData}
          onChangeColumnShowType={setColumnShowType}
          onShowStatistics={onShowStatistics}
          isRenderOperateTable={false} // 暂时
          OperateComponent={OperateComponent}
          className="MatrixTable"
          renderRowClass={renderRowClass}
          rowHeight={rowHeight}
        />
      </div>
    </>
  )
}

export default TableContainer
